(() => {
const maxWaitTime = 6000;
const intervalTime = 100;
let elapsedTime = 0;

const interval = setInterval(() => {
    const customFields = document.querySelector(".custom-fields");
    if (customFields) {
        handleCart();
        clearInterval(interval); 
    }

    elapsedTime += intervalTime;
    if (elapsedTime >= maxWaitTime) {
        clearInterval(interval);
    }
}, intervalTime);


})();

function handleCart(){
  var children = $(".custom-fields").children();
  children.slice(0, 2).wrapAll('<span id="a"></span>');
  children.slice(2, 4).wrapAll('<span id="b"></span>');
  children.slice(4).wrapAll('<span id="c"></span>');
  let b = document.getElementById("b");
  let c = document.getElementById("c");
  if (b && c) {
    let parent = b.parentNode;
    parent.insertBefore(c, b);
  }
  $(".custom-fields #b").after($(".cart__ctas"))
}